import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=1394753e&scoped=true&"
import script from "./ImageModal.vue?vue&type=script&lang=ts&"
export * from "./ImageModal.vue?vue&type=script&lang=ts&"
import style0 from "./ImageModal.vue?vue&type=style&index=0&id=1394753e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1394753e",
  null
  
)

export default component.exports